import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import {
  DELETE_OPERATOR_MASTER,
  FETCH_OPERATOR_MASTER,
  GET_OPERATOR_MASTER,
} from 'actions/operatorMaster';
import OperatorMasterForm from './OperatorMasterForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const OperatorMasterList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [operatorMasterId, setOperatorMasterId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });

  const page = useSelector((state) => state.operatorMaster?.page || 1);
  const totalData = useSelector((state) => state.operatorMaster?.total || 0);
  const limit = useSelector((state) => state.operatorMaster?.limit || 10);
  const totalPages = useSelector((state) => state.operatorMaster?.totalPages || 1);
  const operatorMasterList = useSelector((state) => state.operatorMaster?.operatorMasters || []);
  const isLoader = useSelector((state) => state.operatorMaster?.isLoading || false);

  const getOperatorMasters = useCallback(
    (data = {}) => {
      const payload = {
        ...data,
      };
      if (searchText) {
        payload.search = searchText;
      }
      dispatch({ type: FETCH_OPERATOR_MASTER.REQUEST, payload });
    },
    [dispatch, searchText]
  );

  const getOperatorMasterDetail = useCallback(
    (id) => {
      dispatch({ type: GET_OPERATOR_MASTER.REQUEST, payload: id });
    },
    [dispatch]
  );

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setOperatorMasterId('');
  };

  const deleteOperatorMaster = useCallback(() => {
    dispatch({
      type: DELETE_OPERATOR_MASTER.REQUEST,
      payload: operatorMasterId,
      cb: (res) => {
        if (_.get(res, 'status', '') === DELETE_STATUS_CODE || res === 204 || res?.status === 204) {
          handleCloseDeleteModel();
          getOperatorMasters({ page: 1 });
        }
      },
    });
  }, [dispatch, operatorMasterId, getOperatorMasters]);

  useEffect(() => {
    getOperatorMasters();
  }, [getOperatorMasters]);

  const handleSearch = () => {
    getOperatorMasters({ page: 1 });
  };

  const handlePageClick = useCallback(
    (pageVal) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, pageVal);
      } else {
        const data = {
          page: pageVal.selected + 1,
        };
        getOperatorMasters(data);
      }
    },
    [sortByItem, getOperatorMasters]
  );

  const getSortByItem = (name, order, pageVal) => {
    const sortedOrder = order || 'asc';
    if (pageVal) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: pageVal.selected + 1,
      };
      getOperatorMasters(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getOperatorMasters(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Operator Master" />
        <div className="page-content-wrapper scrollable">
          <div className="stationAccessTypeList-page">
            <Card>
              <div className="stationAccessTypeList-page-wrapper">
                <Row className="stationAccessTypeList-search-box">
                  <Col xl={10} lg={9} md={8} className="stationAccessTypeList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      placeholder="Search Operator by name..."
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="stationAccessTypeList-search-boxButton">
                    <Button
                      className="stationAccessTypeList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Operator
                    </Button>
                  </Col>
                </Row>
                <div className="stationAccessTypeList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th style={{ width: '80px' }}>Logo</th>
                          <th>
                            <div className="sorting">
                              <span>Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>Website</th>
                          <th>Created At</th>
                          <th className="action-col">
                            <div className="sorting">
                              <span>{t('ownershipTypeListForm.action')}</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">{t('placeHolder.loading')}</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(operatorMasterList) ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="empty-data-block">No Operator Master Data Available</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(operatorMasterList, (item, key) => {
                            const itemId = item._id || item.id;
                            return (
                              <tr key={`operator-master-${itemId || key}`}>
                                <td>
                                  {item.logo_url ? (
                                    <img
                                      src={item.logo_url}
                                      alt={item.name}
                                      style={{ width: '40px', height: '40px', objectFit: 'contain', borderRadius: '4px', background: '#f8f9fa' }}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                      }}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '4px',
                                        background: '#e9ecef',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#6c757d',
                                      }}
                                    >
                                      {item.name ? item.name.charAt(0).toUpperCase() : 'O'}
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <strong>{_.get(item, 'name', '-')}</strong>
                                </td>
                                <td>
                                  {item.website ? (
                                    <a href={item.website} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                                      {item.website}
                                    </a>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td>{item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss') : '-'}</td>
                                <td>
                                  <span
                                    className="stationAccessTypeList-table-editIcon"
                                    onClick={() => {
                                      setShowForm(true);
                                      getOperatorMasterDetail(itemId);
                                      setIsEdit(true);
                                    }}
                                  >
                                    <FiEdit2 title="Edit" />
                                  </span>
                                  <span
                                    className="stationAccessTypeList-table-deleteIcon"
                                    onClick={() => {
                                      setShowDeleteModal(true);
                                      setOperatorMasterId(itemId);
                                    }}
                                  >
                                    <RiDeleteBinLine title="Delete" />
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(operatorMasterList) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered onHide={handleCloseForm}>
            <OperatorMasterForm onClose={handleCloseForm} isEdit={isEdit} onSuccess={() => getOperatorMasters({ page: 1 })} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="Operator Master" onClose={handleCloseDeleteModel} onRemove={deleteOperatorMaster} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};

export default OperatorMasterList;
